import { getResourcePath } from '@spotahome/soyuz/client';

import SliderTrackImage from '../SliderTrackImage';
import SliderTrackFloorPlan from '../SliderTrackFloorPlan';
import SliderTrackVideo from '../SliderTrackVideo';
import SliderTrackMap from '../SliderTrackMap';
import SliderTrackViewer360 from '../SliderTrackViewer360';

import Photos from '../icons/Photos';
import Video from '../icons/Video';
import Floorplan from '../icons/Floorplan';
import ThreeSixty from '../icons/ThreeSixty';
import Map from '../icons/Map';
import OtherRooms from '../icons/OtherRooms';

import {
  IMG_TYPE,
  PLAN_TYPE,
  VIDEO_TYPE,
  MAP_TYPE,
  V360_TYPE,
  OTHER_ROOMS_TYPE
} from './constants';

const renderCorrelation = {
  [IMG_TYPE]: SliderTrackImage,
  [PLAN_TYPE]: SliderTrackFloorPlan,
  [VIDEO_TYPE]: SliderTrackVideo,
  [MAP_TYPE]: SliderTrackMap,
  [V360_TYPE]: SliderTrackViewer360
};

const counterLiteralCorrelation = {
  [IMG_TYPE]: 'slider.counter.photos',
  [PLAN_TYPE]: 'slider.counter.floorplans',
  [VIDEO_TYPE]: 'slider.counter.videos'
};

const iconCarouselCorrelation = {
  [IMG_TYPE]: Photos,
  [PLAN_TYPE]: Floorplan,
  [VIDEO_TYPE]: Video,
  [MAP_TYPE]: Map,
  [V360_TYPE]: ThreeSixty,
  [OTHER_ROOMS_TYPE]: OtherRooms
};

const carouselBackgroundCorrelation = {
  [IMG_TYPE]: getResourcePath('/images/slider/track-background-photos.jpg'),
  [PLAN_TYPE]: getResourcePath('/images/slider/track-background-floorplan.jpg'),
  [VIDEO_TYPE]: getResourcePath('/images/slider/track-background-video.jpg'),
  [MAP_TYPE]: getResourcePath('/images/slider/track-background-map.jpg'),
  [V360_TYPE]: getResourcePath(
    '/images/slider/track-background-threesixty.jpg'
  ),
  [OTHER_ROOMS_TYPE]: getResourcePath(
    '/images/slider/track-background-photos.jpg'
  )
};

const galleryModifiersCorrelation = {
  [PLAN_TYPE]: {
    height: '80%',
    width: '80%'
  },
  [MAP_TYPE]: {
    height: '70%'
  },
  [V360_TYPE]: {
    height: '80%',
    width: '100%'
  }
};

export const getComponentToRender = type => renderCorrelation[type];

export const getLiteralToDisplay = type => counterLiteralCorrelation[type];

export const getModifier = type => galleryModifiersCorrelation[type] || {};

export const getCarouselIconToDisplay = type => iconCarouselCorrelation[type];

export const getCarouselBackgroundToDisplay = type =>
  carouselBackgroundCorrelation[type];

export default {
  getComponentToRender,
  getLiteralToDisplay,
  getModifier,
  getCarouselIconToDisplay,
  getCarouselBackgroundToDisplay
};
